import { useGlobalStore } from "controller/store/globalStore";

/**
 * Feature entitlement flags.
 *
 * TEMPORARY (2026-06-03): the AI-feature entitlement (whether the tenant has
 * purchased the AI add-on) is not yet surfaced by the backend. This returns a
 * dummy `true` so the AI routing cards render during development. When the
 * backend exposes the real flag (e.g. on MSP details / subscription), replace
 * the body with that read — every consumer (`useIsAiFeatureEnabled`) updates
 * automatically.
 *
 * Gates: Boards detail AI-routing card, Team-member Permissions AI-routing card.
 */
export const useIsAiFeatureEnabled = (): boolean => {
  // TODO(backend): replace dummy with the real entitlement flag.
  return false;
};

/**
 * Voice input (dictation) entitlement — the one switch for every mic.
 *
 * Voice follows the same gate as every other AI feature: on only while
 * DeskDay AI (Helena) is active for the MSP (`helena_enabled`), the flag behind
 * the AI home. Every surface follows, because `useVoiceDictation` reports
 * itself unavailable. The session mint is meant to refuse the same MSPs
 * server-side (403 `dictation_disabled`) — requested from the backend 2026-10-22.
 * Design: .claude/projects/shared/voice-dictation-editors/DESIGN.md §3.1.1.
 *
 * Gates: Ask Helena home, ticket chat, Helena compose, pinned chat, and every
 * rich-text editor rendered through `WithDictation`.
 *
 * TODO(backend): when the AI purchase plan ships (PENDING-APIS X-1, read via
 * `useIsAiFeatureEnabled`), gate voice by the same rule the other AI features
 * adopt; today they all follow `isHelenaActive`.
 */
export const useIsVoiceDictationEnabled = (): boolean =>
  useGlobalStore((state) => !!state.isHelenaActive);
